var Track = {

    /**
     * Analytics Track Page View
     */
    page: function (url) {
        if (url) {
            return Track.pushData({'event': 'virtualTrackPage', 'page': url});
        } else {
            return Track.pushData({'event': 'trackPage'});
        }
    },

    /**
     * Analytics Track Event
     *
     * @param category
     * @param action
     * @param label
     * @param value
     */
    analyticsEvent: function (category, action, label, value) {
        return Track.pushData({'event': 'analyticsEvent', 'eventCategory': category, 'eventAction': action, 'eventLabel': label, 'eventValue': value});
    },

    /**
     * Analytics Custom Var
     *
     * @param name
     * @param value
     * @param slot
     * @param scope
     */
    analyticsCustomVar: function (name, value, slot, scope) {
        return Track.pushData({'event': 'analyticsCustomVar', 'customVarName': name, 'customVarValue': value, 'customVarSlot': slot, 'customVarScope': scope});
    },

    /**
     * Tag Manager Track Event
     *
     * @param event
     * @param params
     */
    event: function (event, params) {
        if (!params) {
            params = {};
        }
        params.event = event;
        return Track.pushData(params);
    },

    /**
     * Trigger Conversion Event
     *
     * @param label
     * @param value
     */
    triggerConversion: function (label, value) {
        return Track.pushData({'event': 'triggerConversion', 'conversionLabel': label, 'conversionValue': value});
    },

    /**
     * Trigger Registration Success
     *
     * @param key
     */
    triggerRegistrationSuccess: function (key) {
        return Track.pushData({'event': 'hardwareRegistration', 'product': key});
    },

    /**
     * Trigger for external links
     * @param link
     * @param category
     * @param action
     * @see https://support.google.com/analytics/answer/1136920?hl=en
     */
    trackOutboundLink: function (link, category, action) {

        var proceed = function() {
            link.target == '_blank' ? window.open(link.href) : document.location.href = link.href;
        };

        return Track.analyticsEvent(category, action, '', '')
            .then(proceed, proceed);
    },

    /**
     * Performs a data layer push request
     * @param data
     */
    pushData: function (data, timeout) {
        timeout = timeout || 1000;

        var callback = data.eventCallback || function() {},
            deferred = jQuery.Deferred(),
            internalCallback = function() {
                if (schedule) {
                    clearTimeout(schedule);
                    schedule = null;
                    callback();
                    deferred.resolve();
                }
            },
            schedule = setTimeout(internalCallback, timeout);

        data.eventCallback = internalCallback;

        dataLayer.push(data);

        if (window.devMode) {
            console.log('dataLayer.push', data);
        }

        return deferred.promise();
    },

    /**
     * Performs ecommerce event tracking
     * @param action
     * @param ecommerce
     * @param callback
     */
    ecommerceEvent: function (action, ecommerce, callback) {

        return Track.pushData({event: 'analyticsEvent', eventCategory: 'Ecommerce', eventAction: action, ecommerce: ecommerce, eventCallback: callback});
    },

    /**
     * Push data to the dataLayer that is declared with data attributes on an html element
     *
     * @param el
     */
    pushElementData: function (el) {

        var data = jQuery(el).data(),
            event = {},
            property;

        if (data.pushed) {
            return;
        }

        for (property in data) {
            if (property.slice(0, 5) === 'layer') {
                event[property.charAt(5).toLowerCase() + property.slice(6)] = data[property];
            }
        }

        Track.pushData(event);

        jQuery(el).data('pushed', event);
    },

    trackElements: function() {
        jQuery('[data-layer-event]').not('a').each(function() {
            Track.pushElementData(this);
        });
    }

};

/**
 * General Track Events
 */
(function ($) {
    $(function () {

        // unique user hash
        if (Util.getParameter('uuh') != '' && Util.getParameter('uuh') != Util.getCookie('uuh')) {
            Util.setCookie('uuh', Util.getParameter('uuh'), null, 60 * 60 * 24 * 365 * 2);
        }

        // download links
        $(document).on('click', '.ga-event-download', function () {
            var a = document.createElement('a');
            a.href = $(this).attr('href');
            Track.analyticsEvent('Download Button', a.pathname.split('/').pop(), ($(this).attr('title') || $(this).text()).trim(), 1);
        });

        // modal popups
        $(document).on('click', '.btn, .popup', function () {
            if ($(this).data('toggle') == 'modal') {
                Track.analyticsEvent('Modal Open', $(this).attr('href'), $(this).text(), $(this).attr('title'));
            }
        });

        // popover
        $(document).on('click', '.popover-link', function () {
            Track.analyticsEvent('Popover Open', $(this).attr('href'), $(this).text(), $(this).attr('title'));
        });

        // external links
        $(document).on('click', '.external-link', function () {
            Track.trackOutboundLink(this, 'Outbound Links', $(this).attr('href'));
            return false;
        });

        $(document).on('click', '.demodownload-wrong-email', function () {
            Track.analyticsEvent('Demo Download Wrong E-Mail Click', $(this).attr('href'), $(this).text(), 1);
        });

        // Track Upgrade notifications / clicks
        Account.getUserData()
            .then(function(data) {
                if (!data || !data.loggedIn) return;

                var newUpgrades = Util.arrayDiff(data.upgrades || [], data.shown_upgrades || []);

                if (newUpgrades.length) {
                    Track.analyticsEvent('My Offers', 'notification', newUpgrades.length, newUpgrades);
                }

                $(document).on('click', '.account-snippet-link:has(.upgrades-count)', function(e) {
                    Track.analyticsEvent('My Offers', 'menu_click', $(this).text(), newUpgrades);
                });
            });


        Track.trackElements();

        $(document).on('click', 'a[data-layer-event]', function() {
            Track.pushElementData(this);
        });


    });


})(jQuery);



(function() {

    // This section contains the tracking of the Sound Player (nisp)
    function trackNisp() {

        // The state variables are used to store information about the currently playing track
        // until the event is sent
        var title = '',
            startPosition = 0,
            currentPosition = 0,
            flush = false;

        function flushPlay() {
            var amountPlayed = Math.round((currentPosition - startPosition) * 100);

            // The amountPlayed can be negative if the user seeks very fast & the progress was not updated yet.
            // In this case we don't send anything?
            if (flush && amountPlayed > 0) {
                Track.analyticsEvent('Audio', 'Played', title, amountPlayed);
                flush = false;
            }
        }



        // On play, the event is not sent immediately but it's deferred until after some
        // terminating action to be able track how much of the duration of the track
        // the user listened to. The action can be either pausing or skipping a track (previous,
        // next) or leaving the current page by clicking a link or closing the window
        nisp.on('play', function() {
            flushPlay();
            var state = nisp.getState();
            var newTitle = state.currentItem.title + ' - ' + state.currentItem.chapters[state.currentChapterId].title;

            flush = true;

            if (title === newTitle) {
                // Still playing the same track
                startPosition = currentPosition;
            } else {

                title = newTitle;
                startPosition = 0;
                currentPosition = 0;
            }
        });

        // Only update the amount of progress
        nisp.on('progress', function(progress) {

            currentPosition = progress;
        });

        // Flush the buffered play, send a pause event
        nisp.on('pause', function() {
            flushPlay();
            Track.analyticsEvent('Audio', 'Paused', title);
        });

        // Flush the buffered play, send a stop event
        nisp.on('stop', function() {
            flushPlay();
            Track.analyticsEvent('Audio', 'Stopped', title);
        });

        // Send a seek event
        nisp.on('seek', function(pos) {
            flushPlay();
            startPosition = pos;

            flush = true;
            Track.analyticsEvent('Audio', 'Seeked', title);
        });

        // Send next event
        nisp.on('next', function() {
            Track.analyticsEvent('Audio', 'Skipped Forward', title);
        });

        // Send prev event
        nisp.on('prev', function() {
            Track.analyticsEvent('Audio', 'Skipped Backward', title);
        });

        // Just flush the buffered play event
        jQuery(window).on('beforeunload', flushPlay);

    }

    /**
     * Tracking library can be loaded before or after nisp
     */
    if (window.nisp) {
        trackNisp();
    } else {
        jQuery(window).on('nisp', trackNisp);
    }

})();

/**
 * Legacy NI tracking
 */

function triggerConversion(label, value) {}
